// DO NOT set the `name` and `ticker` properties manually
// Instead use one of the get token metadata scripts https://github.com/ExodusMovement/exodus-core/tree/master/packages/assets-base#get-token-metadata

export default [
  {
    name: '6p6x_solana_056c2704',
    displayName: 'OFFICIAL TRUMP',
    decimals: 6,
    ticker: '6P6Xsolana056C2704',
    displayTicker: 'TRUMP',
    mintAddress: '6p6xgHyF7AeE6TZkSmFsko444wqoP15icUSqi2jfGiPN',
    info: {
      description:
        'TRUMP tokens are now live on the blockchain. On July 13, 2024, President Trump faced death and rose with strength and courage, rallying the world with his iconic battle cry FIGHT FIGHT FIGHT. This moment ignited a movement and became the meme of the century.',
      twitter: 'https://twitter.com/GetTrumpMemes',
      website: 'https://gettrumpmemes.com/',
    },
    primaryColor: '#B42B2A',
    gradientColors: ['#070733', '#B42B2A'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'fuaf_solana_2f933a22',
    displayName: 'Official Melania Meme',
    decimals: 6,
    ticker: 'FUAFsolana2F933A22',
    displayTicker: 'MELANIA',
    mintAddress: 'FUAfBo2jgks6gB4Z4LfZkqSZgzNucisEHqnNebaRxM1P',
    info: {
      description:
        'Melania memes are digital collectibles designed to express support for and engage with the values symbolized by MELANIA.',
      twitter: 'https://twitter.com/MELANIATRUMP',
      website: 'https://melaniameme.com/',
    },
    primaryColor: '#FFFFFF',
    gradientColors: ['#DEDEDE', '#FFFFFF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: '3twg_solana_3835713e',
    displayName: 'Kitten Haimer',
    decimals: 9,
    ticker: '3TWGsolana3835713E',
    displayTicker: 'KHAI',
    mintAddress: '3TWgDvYBL2YPET2LxnWAwsMeoA8aL4DutNuwat2pKCjC',
    info: {
      description:
        'Kitten Haimer is a community-driven crypto token promoting unity and protection against market volatility, embodying vigilance and stability in the digital landscape.',
      telegram: 'https://t.me/+sAOenzN-GI4yMzk0',
      twitter: 'https://x.com/KittenHaimer',
      website: 'https://kittenhaimer.ai/',
    },
    primaryColor: '#F8BC4E',
    gradientColors: ['#DD9F2E', '#F8BC4E'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: '7dhb_solana_c9e04412',
    displayName: 'Lido Staked SOL',
    decimals: 9,
    ticker: '7DHBsolanaC9E04412',
    displayTicker: 'stSOL',
    mintAddress: '7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj',
    info: {
      description:
        'When someone stakes their SOL with Lido, they instantly receive stSOL tokens in return. The stSOL tokens increase in value over time and can be used in other DeFi products while the SOL is staked.',
      telegram: 'https://t.me/lidofinance',
      reddit: 'https://reddit.com/r/lidofinance',
      twitter: 'https://twitter.com/lidofinance',
      website: 'https://www.lido.fi',
    },
    primaryColor: '#00A3FF',
    gradientColors: ['#00A3FF', '#3ADCFF'],
    gradientCoords: { x1: '29.931%', y1: '11.994%', x2: '10.494%', y2: '28.187%' },
  },
  {
    name: '7i5k_solana_c9e04412',
    displayName: 'STEPN',
    decimals: 9,
    ticker: '7I5KsolanaC9E04412',
    displayTicker: 'GMT',
    mintAddress: '7i5KKsX2weiTkry7jA4ZwSuXGhs5eJBEjY8vVxR4pfRx',
    primaryColor: '#E6BC7B',
    gradientColors: ['#FFE5C0', '#E6BC7B'],
    gradientCoords: { x1: '3%', y1: '8.5%', x2: '41.043%', y2: '26.738%' },
  },
  {
    name: '8hgy_solana_43b58185',
    displayName: 'COPE',
    decimals: 6,
    ticker: '8HGYsolana43B58185',
    displayTicker: 'COPE',
    mintAddress: '8HGyAAB1yoM1ttS7pXjHMa3dukTFGQggnFFH3hJZgzQh',
    info: {
      description:
        'Cope ranks and indexes online call makers (such as trader influencers on social media), and filters out the ones who make low quality calls. This creates a powerful leaderboard that can be used to follow the top call makers.',
      twitter: 'https://twitter.com/unlimitedcope',
      website: 'https://www.unlimitedcope.com',
    },
    primaryColor: '#77B0DD',
    gradientColors: ['#44b6BB', '#77B0DD'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'audius_solana',
    displayName: 'Audius',
    decimals: 8,
    ticker: 'AUDIOSOL',
    displayTicker: 'AUDIO',
    mintAddress: '9LzCMqDgTKYz9Drzqnpgee3SGa89up3a247ypMj2xrqM',
    primaryColor: '#ED43FF',
    gradientColors: ['#EAEAEA', '#FFF'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'aury_solana_c9e04412',
    displayName: 'Aurory',
    decimals: 9,
    ticker: 'AURYsolanaC9E04412',
    displayTicker: 'AURY',
    mintAddress: 'AURYydfxJib1ZkTir1Jn1J9ECYUtjb6rKQVmtYaixWPP',
    info: {
      description:
        'Aurory is a Solana-based role-playing game that rewards players with NFTs and tokens. Its universe has a blend of Japanese, retro, and futuristic styles, including hand-drawn art.',
      twitter: 'https://twitter.com/auroryproject',
      website: 'https://aurory.io/',
      telegram: 'https://t.me/aurory_project',
    },
    primaryColor: '#B53BE1',
    gradientColors: ['#8312AC', '#B53BE1'],
    gradientCoords: { x1: '22.6%', y1: '7.867%', x2: '22.426%', y2: '30.81%' },
  },
  {
    name: 'eche_solana_c5cba5c4',
    displayName: 'Bonfida',
    decimals: 6,
    ticker: 'ECHEsolanaC5CBA5C4',
    displayTicker: 'FIDA',
    mintAddress: 'EchesyfXePKdLtoiZSL8pBe8Myagyy8ZRqsACNCFGnvp',
    info: {
      description:
        'FIDA is a Solana-based governance token that offers multiple services such as a graphical user interface for the Serum DEX and Solana data analytics.',
      website: 'https://bonfida.org/#/',
      telegram: 'https://t.me/bonfidatg',
    },
    primaryColor: '#6868FC',
    gradientColors: ['#A0A0FF', '#6868FC'],
    gradientCoords: { x1: '-4.68%', y1: '1.381%', x2: '48.573%', y2: '30.414%' },
  },
  {
    name: '7atg_solana_3506aeb0',
    displayName: 'Catwifhat',
    decimals: 2,
    ticker: '7ATGsolana3506AEB0',
    displayTicker: 'CWIF',
    mintAddress: '7atgF8KQo4wJrD5ATGX7t1V2zVvykPJbFfNeVf1icFv1',
    info: {
      description: 'Catwifhat is a deflationary memecoin on the Solana network.',
      website: 'https://www.catwifhatsolana.com/',
    },
    primaryColor: '#DBDBDB',
    gradientColors: ['#FFFFFF', '#DBDBDB'],
    gradientCoords: { x1: '-4.68%', y1: '1.381%', x2: '48.573%', y2: '30.414%' },
  },
  {
    name: 'dezx_solana_3b523050',
    displayName: 'Bonk',
    decimals: 5,
    ticker: 'DEZXsolana3B523050',
    displayTicker: 'BONK',
    mintAddress: 'DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263',
    info: {
      description: 'BONK is a memecoin that gave users airdrops of BONK on the Solana network.',
      website: 'https://www.bonkcoin.com/',
    },
    primaryColor: '#6868FC',
    gradientColors: ['#A0A0FF', '#6868FC'],
    gradientCoords: { x1: '-4.68%', y1: '1.381%', x2: '48.573%', y2: '30.414%' },
  },
  {
    name: 'gene_solana_c9e04412',
    displayName: 'Genopets',
    decimals: 9,
    ticker: 'GENEsolanaC9E04412',
    displayTicker: 'GENE',
    mintAddress: 'GENEtH5amGSi8kHAtQoezp1XEXwZJ8vcuePYnXdKrMYz',
    info: {
      description:
        'Genopets is a game that rewards users for being active while raising their in-game Genopet. The GENE token offers staking, NFT-creation, exclusive features, and governance of the Genopets platform.',
      reddit: 'https://reddit.com/r/genopets',
      twitter: 'https://twitter.com/genopets',
      website: 'https://www.genopets.me/',
    },
    primaryColor: '#00FFC8',
    gradientColors: ['#00AE89', '#00FFC8'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'jupy_solana_ed7ebe51',
    displayName: 'Jupiter',
    decimals: 6,
    ticker: 'JUPYsolanaED7EBE51',
    displayTicker: 'JUP',
    mintAddress: 'JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN',
    info: {
      description:
        'JUP is the governance token of the Jupiter platform, originally split 50% to the community and 50% to the Jupiter ecosystem team.  Holders are expecting to vote on token mints and initiatives within the Jupiter platform.',
      twitter: 'https://twitter.com/JupiterExchange',
      website: 'https://jup.ag/',
    },
    primaryColor: '#00FFC8',
    gradientColors: ['#98C158', '#C7F284'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'kinx_solana_bf1442d2',
    displayName: 'KIN',
    decimals: 5,
    ticker: 'KINXsolanaBF1442D2',
    displayTicker: 'KIN',
    mintAddress: 'kinXdEcpDQeHPEuQnqmUgtYykqKGVFq6CeVX5iAHJq6',
    info: {
      description:
        'Kin is used as money in consumer apps and services in the spaces of gaming, finance, communication, and more. By implementing Kin, apps can offer their users the ability to earn, pay, or transfer cryptocurrency.',
      telegram: 'https://t.me/TheKinChannel',
      reddit: 'https://reddit.com/r/KinFoundation',
      twitter: 'https://twitter.com/kin_ecosystem',
      website: 'https://kin.org',
    },
    primaryColor: '#946DFC',
    gradientColors: ['#EAEAEA', '#FFF'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'mang_solana_c5cba5c4',
    displayName: 'Mango',
    decimals: 6,
    ticker: 'MANGsolanaC5CBA5C4',
    displayTicker: 'MNGO',
    mintAddress: 'MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac',
    info: {
      description:
        'MNGO is a governance token for Mango, a DAO offering margin trading, lending, and perpetual futures. Powered by Solana, Mango’s transactions are nearly instant, with fees close to zero. ',
      twitter: 'https://twitter.com/mangomarkets',
      website: 'https://mango.markets/',
    },
    primaryColor: '#EEB91B',
    gradientColors: ['#E54033', '#EEB91B'],
    gradientCoords: { x1: '61.5%', y1: '7.3%', x2: '47.7%', y2: '-6.5%' },
  },
  {
    name: 'mean_solana_c5cba5c4',
    displayName: 'Meanfi',
    decimals: 6,
    ticker: 'MEANsolanaC5CBA5C4',
    displayTicker: 'MEAN',
    mintAddress: 'MEANeD3XDdUmNMsRGjASkSWdC8prLYsoRJ61pPeHctD',
    info: {
      description:
        'MeanFi is a self-custody, trustless bank that connects traditional finance and DeFi. It can save users time and money with services such as money streaming, dollar cost averaging, and searches that find the best prices for Solana-based exchanges.',
      twitter: 'https://twitter.com/meanfinance',
      website: 'https://meanfi.com/',
    },
    primaryColor: '#FF4F4F',
    gradientColors: ['#B7011C', '#FF4F4F'],
    gradientCoords: { x1: '10.5%', y1: '3.5%', x2: '38.5%', y2: '53.5%' },
  },
  {
    name: 'mefn_solana_5d11b887',
    displayName: 'Magic Eden',
    decimals: 6,
    ticker: 'MEFNsolana5D11B887',
    displayTicker: 'ME',
    mintAddress: 'MEFNBXixkEbait3xn9bkm8WsJzXtVsaJEn4c8Sam21u',
    info: {
      description:
        'Magic Eden is the top consumer dApp in crypto for everyone. Their vision is to make digital ownership universal.',
      twitter: 'https://x.com/MEFndn',
      website: 'https://mefoundation.com/',
    },
    primaryColor: '#E42575',
    gradientColors: ['#E42575', '#FFC7C2'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'msol_solana_c9e04412',
    displayName: 'Marinade Staked SOL',
    decimals: 9,
    ticker: 'MSOLsolanaC9E04412',
    displayTicker: 'mSOL',
    mintAddress: 'mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So',
    info: {
      description:
        'Marinade Staked SOL is a token users receive for staking their SOL with Marinade, the first liquid staking protocol built on Solana. While earning staking rewards with Marinade, users can earn even more by using their mSOL for borrowing, lending, and other DeFi use cases.',
      twitter: 'https://twitter.com/MarinadeFinance',
      website: 'https://marinade.finance/',
    },
    primaryColor: '#C8ECE1',
    gradientColors: ['#308DBA', '#C8ECE1'],
    gradientCoords: { x1: '-3.5%', y1: '3.5%', x2: '48.05%', y2: '30.724%' },
  },
  {
    name: 'orca_solana',
    displayName: 'Orca',
    decimals: 6,
    ticker: 'ORCASOL',
    displayTicker: 'ORCA',
    mintAddress: 'orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE',
    info: {
      description:
        'Orca is an AMM on Solana where users can exchange assets with low fees and get rewarded for providing liquidity to trading pools.',
      reddit: 'https://www.reddit.com/r/orca_so',
      twitter: 'https://twitter.com/orca_so',
      website: 'https://orca.so',
      telegram: 'https://t.me/orca_so',
    },
    primaryColor: '#5969DB',
    gradientColors: ['#1D257A', '#5969DB'],
    gradientCoords: { x1: '44.5%', y1: '40%', x2: '-4.548%', y2: '4.017%' },
  },
  {
    name: 'poli_solana_0cc3745c',
    displayName: 'Star Atlas DAO',
    decimals: 8,
    ticker: 'POLIsolana0CC3745C',
    displayTicker: 'POLIS',
    mintAddress: 'poLisWXnNRwC6oBu1vHiuKQzFjGL4XDSu4g9qjz9qVk',
    info: {
      description:
        'Star Atlas DAO (POLIS) is the governance token for Star Atlas, an expansive, breathtaking gaming metaverse. POLIS holders can participate in decisions that affect how Star Atlas is operated.',
      reddit: 'https://reddit.com/r/staratlas',
      twitter: 'https://twitter.com/staratlas',
      website: 'https://staratlas.com',
    },
    primaryColor: '#32FFFF',
    gradientColors: ['#32FFFF', '#EDFEFF'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: '2b1k_solana_f3924eb0',
    displayName: 'PayPal USD',
    decimals: 6,
    ticker: '2B1KsolanaF3924EB0',
    displayTicker: 'PYUSD',
    mintAddress: '2b1kV6DkPAnxd5ixfnxCpjxmKwqjjaYmCZfHsFu24GXo',
    info: {
      description: 'A stablecoin pegged to the US Dollar, issued by PayPal.',
      website: 'https://www.paypal.com/pyusd',
    },
    primaryColor: '#0071F3',
    gradientColors: ['#0071F3', '#338EF8'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'raydium',
    displayName: 'Raydium',
    decimals: 6,
    ticker: 'RAY',
    mintAddress: '4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R',
    info: {
      description:
        'Raydium, an AMM (Automated Market Market), powers DeFi on the Solana blockchain, providing on-chain liquidity for the Serum Decentralized Exchange. This means lightning fast token swaps and a whole lot more!',
      twitter: 'https://twitter.com/RaydiumProtocol',
      website: 'https://raydium.io/',
      telegram: 'https://t.me/raydiumprotocol',
    },
    primaryColor: '#3772FF',
    gradientColors: ['#3772FF', '#C200FB'],
    gradientCoords: { x1: '99.911%', y1: '25.033%', x2: '-6.116%', y2: '61.756%' },
  },
  {
    name: 'rndr_solana_4b3ba195',
    displayName: 'Render',
    decimals: 8,
    ticker: 'RNDRsolana4B3BA195',
    displayTicker: 'RENDER',
    mintAddress: 'rndrizKT3MK1iimdxRdWabcF7Zg7AR5T4nud4EkHBof',
    info: {
      description:
        'Render is a token that creators can pay to node operators to get GPU rendering power for their work on images, animation, and special effects. This saves creators money as it’s cheaper than in-house rendering, and it allows node operators to earn RNDR with their idle GPUs.',
      reddit: 'https://www.reddit.com/r/RenderToken/',
      twitter: 'https://twitter.com/rendertoken',
      website: 'https://rendertoken.com/',
      telegram: 'https://t.me/RenderTokenOfficial',
    },
    primaryColor: '#FF5A5A',
    gradientColors: ['#E62249', '#FF5A5A'],
    gradientCoords: { x1: '38%', y1: '37.5%', x2: '0.537%', y2: '6.714%' },
  },
  {
    name: 'serum',
    displayName: 'Serum',
    decimals: 6,
    ticker: 'SRM',
    mintAddress: 'SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt',
    info: {
      description:
        'SRM tokens power Serum, a centralized exchange software system built on the Solana blockchain. It allows for trading of cryptocurrencies and has the advantage of a cross-chain support, meaning that it enables a trustless exchange of crypto between various blockchains.',
      reddit: 'https://www.reddit.com/r/ProjectSerum/',
      twitter: 'https://twitter.com/ProjectSerum',
      website: 'https://projectserum.com/',
    },
    primaryColor: '#71E0EC',
    gradientColors: ['#71E0EC', '#05AAC5'],
    gradientCoords: { x1: '0%', y1: '-.006%', x2: '99.694%', y2: '99.694%' },
  },
  {
    name: 'smoothlovepotion_solana',
    displayName: 'Smooth Love Potion',
    decimals: 8,
    ticker: 'SLPSOL',
    displayTicker: 'SLP',
    mintAddress: '4hpngEp1v3CXpeKB81Gw4sv7YvwUVRKvY3SGag9ND8Q4',
    primaryColor: '#77BAA1',
    gradientColors: ['#EAEAEA', '#FFF'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'staratlas_solana',
    displayName: 'Star Atlas',
    decimals: 8,
    ticker: 'ATLASSOL',
    displayTicker: 'ATLAS',
    mintAddress: 'ATLASXmbPQxBUYbxPsV97usA3fPQYEqzQBUHgiFCUsXx',
    info: {
      description:
        'Star Atlas is a massive multiplayer online game in a breathtaking metaverse run on Solana. Players can travel in space, build space stations, form alliances, and battle for virtual assets.',
      reddit: 'https://reddit.com/r/staratlas',
      twitter: 'https://twitter.com/staratlas',
      website: 'https://staratlas.com',
      telegram: 'https://t.me/staratlasgame',
    },
    primaryColor: '#32FFFF',
    gradientColors: ['#32FFFF', '#EDFEFF'],
    gradientCoords: { x1: '44.5%', y1: '40%', x2: '-4.548%', y2: '4.017%' },
  },
  {
    name: 'tetherusd_solana',
    displayName: 'Tether USD',
    decimals: 6,
    ticker: 'USDTSOL',
    displayTicker: 'USDT',
    mintAddress: 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
    primaryColor: '#53AE94',
    gradientColors: ['#EAEAEA', '#FFF'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'thegraph_solana',
    displayName: 'The Graph',
    decimals: 8,
    ticker: 'GRTSOL',
    displayTicker: 'GRT',
    mintAddress: 'HGsLG4PnZ28L8A4R5nPqKgZd86zUUdmfnkTRnuFJ5dAX',
    primaryColor: '#33A0FF',
    gradientColors: ['#EAEAEA', '#FFF'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'tulip_solana',
    displayName: 'Tulip Protocol',
    decimals: 6,
    ticker: 'TULIPSOL',
    displayTicker: 'TULIP',
    mintAddress: 'TuLipcqtGVXP9XR62wM8WWCm6a9vhLs7T1uoWBk6FDs',
    info: {
      description:
        'Tulip is the first Solana-powered platform to offer decentralized yield aggregation and auto-compounding vault strategies.',
      twitter: 'https://twitter.com/tulipprotocol',
      website: 'https://tulip.garden',
      telegram: 'https://t.me/tulipprotocol',
    },
    primaryColor: '#1C88B4',
    gradientColors: ['#2BD9B9', '#D141E9'],
    gradientCoords: { x1: '44.5%', y1: '40%', x2: '-4.548%', y2: '4.017%' },
  },
  {
    name: 'usdcoin_solana',
    displayName: 'USDC',
    decimals: 6,
    ticker: 'USDCSOL',
    displayTicker: 'USDC',
    mintAddress: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
    primaryColor: '#3E90E8',
    gradientColors: ['#EAEAEA', '#FFF'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
]
